import { useActiveCircle } from '@/hooks/use-active-circle';
import { useClinicalPacks } from '..';

export function useActiveCircleClinicalPacks(
    packClasses: string[] = [],
    isOrdered = false
) {
    const { activeCircleId } = useActiveCircle();

    return useClinicalPacks(activeCircleId, packClasses, isOrdered);
}
